<div class="value-grid" *ngIf="zahlungsart.value && haftpflichtUebersicht">
  <div class="row praemie-l1">
    <div class="col col-xs-12 col-sm-12">
      <!-- Haftpflicht -->
      <span class="titel"><strong>Haftpflichtversicherung</strong></span>
      <span *ngIf="risikoKfzComponents.toArray().length > 1"> (Fahrzeug {{haftpflichtUebersicht.risikoIndex + 1}} {{haftpflichtUebersicht.marke}} {{haftpflichtUebersicht.modell}})</span>
    </div>
  </div>
  <div class="row praemie-l1">
    <div class="col col-xs-12 col-sm-12">
      <p>
        <!-- Row -->
        <span>{{haftpflichtUebersicht.variante}}, Versicherungssumme: {{haftpflichtUebersicht.versicherungssumme}}<br></span>
        <!-- Row -->
        <span *ngIf="showZugmaschineInfo">Zur Verwendung im Rahmen eines land- und forstwirtschaftlichen Betriebes bestimmt<br></span>
        <!-- Row -->
        <span *ngIf="haftpflichtUebersicht.bmIntern">Bonus-Malus-Stufe {{haftpflichtUebersicht.bmIntern}}<br></span>
        <!-- Row -->
        <span *ngIf="haftpflichtUebersicht.fahrzeugart">{{haftpflichtUebersicht.fahrzeugart}}</span>
        <span *ngIf="haftpflichtUebersicht.marke">, {{haftpflichtUebersicht.marke}}</span>
        <span *ngIf="haftpflichtUebersicht.modell">, {{haftpflichtUebersicht.modell}}</span>
        <span *ngIf="haftpflichtUebersicht.antriebsart">, {{haftpflichtUebersicht.antriebsart}}</span>
        <span *ngIf="haftpflichtUebersicht.hybridart">{{haftpflichtUebersicht.hybridart ? ', ' + dataService.hybridarten.get(haftpflichtUebersicht.hybridart) : null}}</span>
        <span *ngIf="haftpflichtUebersicht.hubraumCcm">, {{haftpflichtUebersicht.hubraumCcm}} ccm</span>
        <span *ngIf="haftpflichtUebersicht.leistungKw">, {{haftpflichtUebersicht.leistungKw}} kW</span>
        <span *ngIf="haftpflichtUebersicht.eigengewichtKg">, {{haftpflichtUebersicht.eigengewichtKg}} kg</span>
        <span *ngIf="haftpflichtUebersicht.erstzulassung">, Erstzulassung: {{haftpflichtUebersicht.erstzulassung | date}}</span>
        <span *ngIf="haftpflichtUebersicht.co2">, CO&#8322; -Ausstoß : {{haftpflichtUebersicht.co2}} {{ co2AusstossMessTyp }}</span>
        <span *ngIf="haftpflichtUebersicht.hoechstgeschwindigkeitKmh">, Höchstgeschwindigkeit: {{haftpflichtUebersicht.hoechstgeschwindigkeitKmh}} km/h</span>
        <span *ngIf="haftpflichtUebersicht.anzahlPlaetze">, Sitzplätze: {{haftpflichtUebersicht.anzahlPlaetze}}</span>
        <span *ngIf="haftpflichtUebersicht.nutzlast">, Nutzlast: {{haftpflichtUebersicht.nutzlast}} kg</span>
        <span *ngIf="haftpflichtUebersicht.gesamtgewicht">, Gesamtgewicht: {{haftpflichtUebersicht.gesamtgewicht}} kg</span>
        <br>
        <!-- Row -->
        <span *ngIf="haftpflichtUebersicht.geburtsdatum">Geburtsdatum: {{haftpflichtUebersicht.geburtsdatum | date}}</span>
        <span *ngIf="haftpflichtUebersicht.geburtsdatumZweiterZulassungsbesitzer">, weiteres Geburtsdatum: {{haftpflichtUebersicht.geburtsdatumZweiterZulassungsbesitzer | date}}</span>
        <br *ngIf="haftpflichtUebersicht.geburtsdatum || haftpflichtUebersicht.geburtsdatumZweiterZulassungsbesitzer">
        <!-- Row -->
        <span *ngIf="haftpflichtUebersicht.region">Zulassungsbezirk: {{haftpflichtUebersicht.region}}<br></span>
      </p>
    </div>
  </div>
  <div class="row praemie-summe">
    <div class="col col-xs-4 col-sm-4 text-right praemie">
      <span class="custom_currency"><strong>Prämie: {{ haftpflichtUebersicht.bruttoPraemie | customCurrency }}</strong></span>
    </div>
  </div>
</div>
<!-- Kaskos -->
<div *ngIf="zahlungsart.value && kaskoUebersicht?.length > 0">
  <div class="value-grid" *ngFor="let kasko of kaskoUebersicht">
    <div class="row praemie-l1">
      <div class="col col-xs-12 col-sm-12">
        <span class="titel"><strong>Kaskoversicherung</strong></span>
        <span *ngIf="risikoKfzComponents.toArray().length > 1"> (Fahrzeug {{kasko.risikoIndex + 1}} {{kasko.marke}} {{kasko.modell}})</span>
      </div>
    </div>
    <div class="row praemie-l1">
      <div class="col col-xs-12 col-sm-12">
        <p>
          <!-- Row -->
          <span>{{ kasko.variante }}</span>
          <span *ngIf="kasko.info">{{kasko.info}}</span>
          <br>
          <span *ngIf="kasko.selbstbehaltVariante">{{kasko.selbstbehaltVariante}}</span>
          <span *ngIf="(kasko.selbstbehalthoehe | async)?.toString() | customCurrency as selbstbehalthoehe">, Selbstbehalt: {{selbstbehalthoehe}}</span>
          <br *ngIf="kasko.selbstbehaltVariante || (kasko.selbstbehalthoehe | async)">
          <!-- Row -->
          <span *ngIf="kasko.listenpreis">Listenpreis: {{ kasko.listenpreis | customCurrency }}</span>
          <span *ngIf="kasko.sonderausstattung">, Sonderausstattung: {{ kasko.sonderausstattung | customCurrency }}</span>
          <br *ngIf="kasko.listenpreis || kasko.sonderausstattung">
          <!-- Row -->
          <span *ngIf="kasko.fahrzeugzustand">{{ kasko.fahrzeugzustand }}</span>
          <span *ngIf="kasko.leasingfahrzeug !== null">, Leasingfahrzeug: {{ kasko.leasingfahrzeug | boolToJaNein | lowercase }}</span>
          <br *ngIf="kasko.fahrzeugzustand || kasko.leasingfahrzeug !== null">
          <!-- Row -->
          <span *ngIf="kasko.leasingklausel !== null">Leasingklausel: {{ kasko.leasingklausel | boolToJaNein | lowercase }}</span>
          <span *ngIf="kasko.neuwertentschaedigung !== null">Neuwertentschädigung/Kasko-PLUS: {{ kasko.neuwertentschaedigung | boolToJaNein | lowercase }}</span>
          <br *ngIf="kasko.leasingklausel !== null || kasko.neuwertentschaedigung !== null">
          <!-- Row -->
          <span *ngIf="kasko.eVorsorgepaket !== null">E-Vorsorgepaket: {{ kasko.eVorsorgepaket | boolToJaNein | lowercase }}</span>
          <br *ngIf="kasko.eVorsorgepaket !== null">
          <!-- Row -->
          <span *ngIf="kasko.vorsteuerabzugsberechtigt !== null">Vorsteuerabzugsberechtigt: {{ kasko.vorsteuerabzugsberechtigt | boolToJaNein | lowercase }}</span>
          <br *ngIf="kasko.vorsteuerabzugsberechtigt !== null">
        </p>
      </div>
    </div>
    <div class="row praemie-summe">
      <div class="col col-xs-4 col-sm-4 text-right praemie">
        <span class="custom_currency">
          <strong>Prämie: {{ kasko.bruttoPraemie | customCurrency }}</strong>
        </span>
      </div>
    </div>
  </div>
</div>
<!-- IU -->
<div class="value-grid" *ngIf="zahlungsart.value && showInsassen">
  <div class="row praemie-l1">
    <div class="col col-xs-12 col-sm-12">
      <span class="titel"><strong>Kfz-Insassenunfallversicherung</strong></span>
    </div>
  </div>
  <div class="row praemie-l1">
    <div class="col col-xs-12 col-sm-12">
      <p>
        <span>{{ insassenUebersicht.variante }}<br></span>
        <span>Versicherungssumme Todesfall: {{ insassenUebersicht.versicherungssummen.todesfall | customCurrency }}<br></span>
        <span>Versicherungssumme Invalidität: {{ insassenUebersicht.versicherungssummen.invaliditaet | customCurrency }}<br></span>
        <span *ngIf="insassenUebersicht.versicherungssummen.heilkosten">Versicherungssumme Heilkosten: {{ insassenUebersicht.versicherungssummen.heilkosten  | customCurrency }}<br></span>
      </p>
    </div>
  </div>
  <div class="row praemie-summe">
    <div class="col col-xs-4 col-sm-4 text-right praemie">
      <span class="custom_currency"><strong>Prämie: {{ insassenUebersicht.bruttoPraemie | customCurrency }}</strong></span>
    </div>
  </div>
</div>
<!-- Motorsteuer -->
<div class="value-grid" *ngIf="zahlungsart.value">
  <div class="row praemie-summe" *ngIf="motorsteuerUebersicht">
    <div class="col col-xs-10 col-sm-10">
      <span class="titel"><strong>Motorbezogene Versicherungssteuer</strong></span>
      <span *ngIf="risikoKfzComponents.toArray().length > 1 && !motorsteuerUebersicht.motorsteuerFolgt"> (Fahrzeug {{ motorsteuerUebersicht.risikoIndex + 1 }} {{ motorsteuerUebersicht.marke }} {{ motorsteuerUebersicht.modell }})</span>
    </div>
    <div class="col col-xs-2 col-sm-2 text-right praemie">
      <span class="custom_currency"><strong>{{ motorsteuerUebersicht.motorsteuerFolgt ? '€ folgt' : motorsteuerUebersicht.motorsteuer | customCurrency }}</strong></span>
    </div>
  </div>
  <div class="row praemie-l1" *ngIf="showMbvInfoWohnMobile">
    <div class="col col-xs-9 col-sm-9">
      <div class="label-infotext" *ngIf="translateService.get(expertMode ? 'MBVINFOEXPERT' : 'MBVINFO') | async as result" [innerHTML]="result">
      </div>
    </div>
  </div>
  <div class="row praemie-summe" *ngIf="kfzResult.Gesamt">
    <div class="col col-xs-6 col-sm-6">
      <div><strong>Summe</strong></div>
    </div>
    <div class="col col-xs-6 col-sm-6 text-right praemie">
      <span class="custom_currency"><strong>{{ kfzResult.Gesamt | customCurrency }}</strong></span>
    </div>
  </div>
</div>
